import { cn } from "@/lib/utils"
import { Loader2 } from "lucide-react"

/**
 * Generic loading spinner.
 *
 */
export function Loading({ className }: { className?: string }) {
  return (
    <Loader2 className={cn("h-8 w-8 animate-spin text-primary", className)} />
  )
}

/**
 * Full page loading, centered loading spinner.
 *
 * Commonly used in loading.tsx for instant loading states.
 */
export default function FullPageLoading({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        "flex items-center justify-center h-[100%] min-h-screen",
        className
      )}
    >
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
    </div>
  )
}
